import useAlert from "../../customHooks/useAlert";

export default function CheckboxField({
  id,
  name,
  register,
  editable
}) {

    const { confirmAlert } = useAlert();

    const handleClick = (event) => {
        event.preventDefault();

        confirmAlert('Are you sure you want to continue?',
            {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            })
        .then((result) => {
                if (result.isConfirmed) {
                    event.target.checked = !event.target.checked;
                    
                    event.target.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        );       
    }

    return (
        <input
            id={id}
            type="checkbox"
            className="form-check-input mt-0"
            disabled={editable}
            {...register(name)}
            onClick={handleClick}
        />
    )
}